import { render, staticRenderFns } from "./ProSpelling.vue?vue&type=template&id=ffda9728&"
import script from "./ProSpelling.vue?vue&type=script&lang=ts&"
export * from "./ProSpelling.vue?vue&type=script&lang=ts&"
import style0 from "./ProSpelling.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports